import SVGBase, { type SVGComponentProps } from './SVGBase';

const path = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M16.6015 4.1597C16.5062 3.49266 16.1892 2.8771 15.7015 2.4122C15.2372 1.91957 14.6175 1.60176 13.9465 1.5122C13.258 1.44026 12.5748 1.68922 12.094 2.1872L10.9015 3.3722L2.60649 11.6747C2.54974 11.7337 2.50851 11.8059 2.48649 11.8847L1.51149 15.9947C1.4752 16.1603 1.52613 16.3329 1.64649 16.4522C1.73654 16.5458 1.86164 16.5975 1.99149 16.5947H2.10399L6.20649 15.6422C6.28534 15.6202 6.35749 15.5789 6.41649 15.5222L14.809 7.1372L15.9265 6.0572C16.4378 5.56633 16.6879 4.86321 16.6015 4.1597ZM3.22149 12.9872L5.12649 14.8922L2.63649 15.4772L3.22149 12.9872ZM6.09399 14.4872L3.64149 12.0572L11.3065 4.3397L13.774 6.8072L6.09399 14.4872ZM15.2365 5.3072L14.4865 6.0572L12.0115 3.6497L12.7615 2.8997C13.0301 2.60569 13.4232 2.45793 13.819 2.5022C14.2687 2.56973 14.6817 2.78945 14.989 3.1247C15.3218 3.43384 15.5411 3.84591 15.6115 4.2947C15.6458 4.67152 15.508 5.04367 15.2365 5.3072Z"
      fill="black"
    />
  </svg>
);

function Pencil({ className, title = 'Pencil' }: SVGComponentProps) {
  return (
    <SVGBase
      className={className}
      labeledBy="pencil-svg"
      path={path}
      title={title}
      viewBox="0 0 18 18"
    />
  );
}

export default Pencil;
